import { FocusEventHandler } from 'react';
import CSS from 'csstype';

import styles from './BasicInput.module.css';

interface InputFieldProps<T extends string | number | string[]> {
  type?: 'text' | 'number' | 'password';
  id: string;
  disabled: boolean;
  label?: JSX.Element;
  value: T;
  placeholder: string;
  setValue: (newValue: string) => void;
  errors?: string | string[] | null;
  // Formik element that triggers validation when blurred
  onBlur: FocusEventHandler<HTMLInputElement>;
  // Formik element that determines if a user has visited a field
  touched: boolean | undefined;
  extraStyles?: CSS.Properties;
}

export const BasicInput = <T extends string | number | string[]>({
  type = 'text',
  id,
  disabled,
  label,
  value,
  placeholder,
  setValue,
  errors,
  onBlur,
  touched,
  extraStyles,
}: InputFieldProps<T>): JSX.Element => {
  return (
    <div className={styles['container']} style={extraStyles}>
      {label && (
        <label htmlFor={id} className={styles['label']}>
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        disabled={disabled}
        aria-label={`${id}-input`}
        aria-invalid={errors ? true : false}
        aria-errormessage={`${id}-error-message`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        onBlur={onBlur}
        className={styles['input']}
        style={{
          borderColor: !touched
            ? 'var(--ea-black)'
            : errors
            ? 'var(--error-color)'
            : 'var(--ea-blue)',
        }}
      />
      {touched && errors && (
        <p id={`${id}-error-message`} className={styles['errors']}>
          {errors}
        </p>
      )}
    </div>
  );
};
